import * as React from 'react'

import { reaction } from 'mobx'

import { observer } from 'mobx-react'

import createEffect from 'modules/core/hooks/createEffect'

import type AllowanceIncidenceForm from 'modules/timeoff/lib/AllowanceIncidence'
import allowances from 'modules/timeoff/store/collections/allowances'

import DaysForm from './DaysForm'
import HoursForm from './HoursForm'

const castSign = createEffect((form: AllowanceIncidenceForm) => {
  reaction(
    () => form.get('sign').value,
    (uncastedSign) => {
      const sign = Number(uncastedSign)

      const normalizedValue = Math.abs(form.get('days_in_cents').value) * sign * 100
      form.get('days_in_cents').mapAndSet(normalizedValue)
    }
  ) // We only need to setup the reaction on mount and to clean it up on
  // unmount, we don't want it to run on the changes of `form`.
})

interface Props {
  form: AllowanceIncidenceForm
}

function Form({ form }: Props) {
  castSign(form)

  const allowanceId = form.get('timeoff_allowance_id').value
  const allowance = allowances.get(allowanceId)

  if (allowance?.isHourly) {
    return <HoursForm form={form} />
  }

  return <DaysForm form={form} />
}

export default observer(Form)
